export class ImageUtility {
    public static readonly BlankImagePath: string = './assets/blank.png';
}
